import { Button } from "../ui/button";

type Props = {
  reload: () => void;
  errorMessage: string;
};

export default function Error({
  reload,
  errorMessage,
}: Props) {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 p-4">
      <div className="max-w-xl w-full">
        {/* Error Card */}
        <div className="bg-white border border-gray-100 p-8 text-center transform transition-all duration-300 hover:shadow-md">

          {/* Error Content */}
          <div className="space-y-4 mb-6">
            
            <div className="bg-red-50 border-l-4 border-red-400 p-4 text-left">
              <p className="text-red-700 text-sm font-medium">
                {errorMessage}
              </p>
            </div>
            
            <p className="text-gray-500 text-sm">
              We encountered an issue while loading the content. Please try again.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={reload}
              className="flex-1 cursor-pointer"
            >
              <div className="flex items-center justify-center gap-2">
                <svg 
                  width="16" 
                  height="16" 
                  fill="currentColor" 
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                </svg>
                Try Again
              </div>
            </Button>
            
            <Button
              onClick={() => window.location.href = '/'}
              className="flex-1 cursor-pointer"
              variant={"outline"}
            >
              Go Home
            </Button>
          </div>

          {/* Support Info */}
          <div className="mt-6 pt-4 border-t border-gray-100">
            <p className="text-xs text-gray-400">
              Need help? Contact{" "}
              <a 
                href="mailto:support@hexad.co.rw" 
                className="text-blue-600 hover:text-blue-700 font-medium underline"
              >
                support@hexad.co.rw
              </a>
            </p>
          </div>
        </div>

        {/* Background decorative elements */}
        <div className="absolute -z-10 top-1/4 left-1/4 w-32 h-32 bg-blue-200 blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute -z-10 bottom-1/4 right-1/4 w-32 h-32 bg-red-200 blur-3xl opacity-20 animate-pulse delay-1000"></div>
      </div>
    </div>
  );
}
